<template>
    <div class="w-full">
        <form id="smmr-form" class="my-2 mx-4 border border-gray-300 bg-gray-100" @submit.prevent="update">
            <h2 class="text-green-600 text-2xl leading-10 pr-8 ml-8 mt-8 text-left">Education record {{ itemIndex + 1 }} <span v-if="itemIndex === 0"> - most recent</span></h2>
            <div class="flex flex-wrap p-8" @change="dirtyForm()" @keydown="dirtyForm">
                <text-input v-model="form.institution_name" class="pr-6" label="* Institution Name"
                            :error="form.errors?.institution_name"
                            @update:modelValue="value = $event"
                />
                <text-input v-model="form.qualification_type"
                            :error="form.errors?.qualification_type"
                            class="pr-6"
                            label="* Qualification Type (Eg Bachelors, Masters, Licenciatura or Diplome)" @update:modelValue="value = $event"
                />
                <text-input v-model="form.subject"
                            :error="form.errors?.subject"
                            class="pr-6" label="* Subject" @update:modelValue="value = $event"
                />
                <text-input v-model="form.final_result"
                            :error="form.errors?.final_result"
                            class="pr-6" label="* Final / Expected Result"
                            @update:modelValue="value = $event"
                />

                <select-input v-model="form.country_id" class="" label="* Country" :error="form.errors?.country_id" @update:modelValue="value = $event">
                    <option v-for="item in countriesOfDomicileList" :key="item.reference" :value="item.reference">{{ item.name }}</option>
                </select-input>

                <text-input v-model="form.tuition_language"
                            :error="form.errors?.tuition_language"
                            class="pr-6"
                            label="* Language of instruction" @update:modelValue="value = $event"
                />
                <text-input v-model="form.start_date" :error="form.errors?.start_date" type="date" label="* Start Date"
                            class="pr-6" @update:modelValue="value = $event"
                />
                <text-input v-model="form.end_date" :error="form.errors?.end_date" type="date" label="End Date" class="pr-6"
                            @update:modelValue="value = $event"
                />
                <textarea-input v-if="!isScOrModule"
                                v-model="form.notes"
                                class="w-full-i bg-green-200 padding-2 mb-4"
                                label="Notes or extenuating circumstances"
                                rows="2"
                                @update:modelValue="value = $event"
                />
                <div class="mb-2">
                    <p>* Was this a distance learning course?</p>
                </div>
                <div class="mb-4 flex justify-start">
                    <div class="w-1/4 mr-3">
                        <input id="dl-yes-option"
                               v-model="form.online_distance_learning"
                               :value="1"
                               type="radio"
                               name="online_distance_learning"
                               @update:modelValue="value = $event"
                        />
                        <label>Yes</label>
                    </div>
                    <div class="w-1/4 ml-3">
                        <input id="dl-no-option"
                               v-model="form.online_distance_learning"
                               :value="0"
                               type="radio"
                               name="online_distance_learning"
                               @update:modelValue="value = $event"
                        />
                        <label>No</label>
                    </div>
                    <span v-if="form.errors?.online_distance_learning" style="color: #a94442">This field is required</span>
                </div>
            </div>
            <div class="items-center">
                <div v-if="successMessage" class="mx-8 success-message">{{ successMessage }}</div>

                <div v-if="Object.keys(validationErrors).length > 0">
                    <p class="server-error mx-8">There were some validation issues, please check the fields above</p>
                </div>
                <div class="flex flex-wrap justify-center">
                    <application-component-save-button :disabled="formDirty" class="relative flex btn-green -ml-0 w-3/4 sm:w-52 justify-center sm:inline-block text-center" type="submit">
                        Save this record
                        <div v-if="loading" class="lds-ring-container absolute top-2 left-2">
                            <div class="lds-ring"><div /><div /><div /><div /></div>
                        </div>
                    </application-component-save-button>
                    <button class="w-3/4 sm:w-52 mt-0 sm:mt-8 my-8 sm:ml-4 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" type="button" @click="removeRecord">
                        Remove this record
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TextInput from '@/shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'
import TextareaInput from '@/shared/TextareaInput'

export default {
    components: {
        ApplicationComponentSaveButton,
        TextInput,
        SelectInput,
        TextareaInput,
    },
    props: {
        countriesOfDomicileList: Object,
        applicationReference: String,
        itemIndex: Number,
        programmeCode: String,
        educationData: {
            type: Object,
            default: function () {
                return {
                    reference: null,
                    start_date: null,
                    end_date: null,
                    country_id: null,
                    institution_name: null,
                    online_distance_learning: null,
                    qualification_type: null,
                    subject: null,
                    final_result: null,
                    tuition_language: null,
                    application_id: this.applicationReference,
                    notes: this.null,
                }
            },
        },
    },
    data() {
        return {
            form: ({
                reference: this.educationData.reference,
                start_date: this.educationData.start_date,
                end_date: this.educationData.end_date,
                country_id: this.educationData.country_id,
                institution_name: this.educationData.institution_name,
                online_distance_learning: this.educationData.online_distance_learning,
                qualification_type: this.educationData.qualification_type,
                subject: this.educationData.subject,
                final_result: this.educationData.final_result,
                tuition_language: this.educationData.tuition_language,
                application_id: this.applicationReference,
                notes: this.educationData.notes,

                errors: {
                },
            }),
            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
        }
    },
    computed: {
        validationErrors: {
            get: function() {
                return this.form.errors
            },
            set: function(newValue) {
                for (const key in newValue)
                {
                    this.form.errors[key] = newValue[key].join(' ')
                }
            },
        },
        isScOrModule() {
            return ['S','U'].includes(this.programmeCode)
        },
    },
    methods: {
        removeRecord() {
            if(confirm('Are you sure you want to remove this education record?'))
            {
                if (this.form.reference !== null)
                {
                    this.$store.dispatch('deleteEducationItem', {
                        applicationReference: this.applicationReference,
                        educationReference: this.form.reference,
                    }).then((response) => {
                        this.loading = false
                        this.form.errors = {}
                        this.successMessage = response.data
                        this.$emit('delete', this.itemIndex)
                    })
                    .catch(error => {
                        this.loading = false
                        this.form.errors = Object.values(error)
                        this.successMessage = ''
                    })
                }
                else
                {
                    this.$emit('delete', this.itemIndex)
                }
            }

        },
        update() {
            this.loading = true

            let method = ''
            if (this.form.reference !== null)
            {
                method = 'updateEducationItem'

            }
            else
            {
                method = 'createEducationItem'
            }

            this.$store.dispatch(method, {
                educationItem: this.form,
                applicationReference: this.applicationReference,
                educationItemReference: this.form.reference,
            }).then((response) => {
                this.loading = false
                this.form.errors = {}
                this.successMessage = response.data.message
                this.form.reference = response.data.reference
            })
            .catch(error => {
                this.loading = false
                this.form.errors = error.response.data.errors
                this.validationErrors = error.response.data.errors
                this.successMessage = ''
            })

            this.formDirty = false
        },
        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
        },
    },
}
</script>